<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="标题" prop="title">
                <el-input clearable v-model="dataForm.title" ></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="description">
                <el-input type="textarea" :rows="3" clearable v-model="dataForm.description" ></el-input>
            </el-form-item>
            <el-form-item label="栏目" prop="categoryId">
                <el-select clearable v-model="dataForm.categoryId" >
                <el-option
                        v-for="item in categorys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="栏目" prop="zslx">
                <el-select clearable v-model="zslxData" multiple>
                    <el-option
                            key="0"
                            label="保安内部系统"
                            value="0"
                    ></el-option>
                    <el-option
                            key="1"
                            label="客户网站平台"
                            value="1"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="缩略图" prop="img">
                <el-upload
                        :action="url"
                        :before-upload="beforeUploadHandle"
                        :on-success="successHandle"
                        :on-remove="handleRemove"
                        list-type="picture-card"
                        :limit="1"
                        :file-list="fileList">
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">最多上传1张图片</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="作者" prop="author">
                <el-input clearable v-model="dataForm.author" ></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="time">
                <el-date-picker
                        v-model="dataForm.time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发布类型">
                <el-select v-model="dataForm.customertype" multiple placeholder="请选择">
                    <el-option
                            v-for="item in customertypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否首页轮播" prop="isIndexScroll">
                <el-radio-group v-model="dataForm.isIndexScroll">
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排序" prop="orderNum">
                <el-input-number clearable v-model="dataForm.orderNum"  controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <u-editor v-model="dataForm.content"></u-editor>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import UEditor from "@/components/ueditor/index";
    export default {
        components: {UEditor},
        data () {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                //表单验证规则
                rules: {
                    title: [{required: true, trigger: 'blur', message: '请输入标题',}],
                    categoryId: [{required: true, trigger: 'blur', message: '请输入栏目id',}],
                    content: [{required: true, trigger: 'blur', message: '请输入内容',}],
                    time: [{required: true, trigger: 'blur', message: '请输入发布时间',}],
                    isIndexScroll: [{required: true, trigger: 'blur', message: '请选择是否首页轮播',}],
                    orderNum: [{required: true, trigger: 'blur', message: '请输入排序',}],
                    customertype: [{required: true, trigger: 'blur', message: '请输入发布类型',}],
                },
                url: '',
                fileList: [],
                visible: false,
                menuList: [],
                customerList:[],
                dataForm: {
                id: '',
                title: '',
                description: '',
                categoryId: '',
                zslx:'',
                content: '',
                img: '',
                author: '',
                time: '',
                isIndexScroll: '',
                orderNum: '',
                customertype:[]
                },
                categorys:[],
                zslxData: [],
                customertypeList:[]
            }
        },
        methods: {
            init (id) {
                this.dataForm= {
                    id: '',
                    title: '',
                    description: '',
                    categoryId: '',
                    zslx:'',
                    content: '',
                    img: '',
                    author: '',
                    time: '',
                    isIndexScroll: '',
                    orderNum: '',
                    customertype:[]
                },//清空缓存
                this.dataForm.id = id
                this.visible = true
                this.url = this.$request.defaults.baseURL + `/bjba/fileupload/upload?access_token=${this.$store.getters.token}`
                this.fileList.splice(0,this.fileList.length);
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    this.zslxData = []
                    if(this.dataForm.id) {
                        this.$http
                        ({
                            url: '/bjba/article/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm.id    = data.data.id
                            this.dataForm.title    = data.data.title
                            this.dataForm.categoryId    = data.data.categoryId
                            this.dataForm.content    = data.data.content
                            this.dataForm.img    = data.data.img
                            this.dataForm.author    = data.data.author
                            this.dataForm.time    = data.data.time
                            this.dataForm.isIndexScroll    = data.data.isIndexScroll
                            this.dataForm.orderNum    = data.data.orderNum
                            this.dataForm.description    = data.data.description
                            this.dataForm.customertype    = data.data.customertype.split(",")
                            this.zslxData = data.data.zslx.split(",")
                            if(this.dataForm.img) {
                                let obj = {url:''};
                                obj.url = data.data.img;
                                this.fileList.push(obj);
                            }
                        })
                    }
                })
                this.getCategory();
                this.getCustomerType()
            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {
                this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    console.log("发布类型数据为：",this.dataForm.customertype)
                    // let customertypearray=this.dataForm.customertype
                    // let customertypestring=""
                    // for (let i=0;i<customertypearray.length;i++) {
                    //     if (i==customertypearray.length-1) {
                    //         customertypestring=customertypestring+customertypearray[i]
                    //     }else {
                    //         customertypestring=customertypestring+customertypearray[i]+","
                    //     }
                    // }
                    // this.dataForm.customertype=customertypestring
                    this.dataForm.customertype = this.dataForm.customertype.join(",")
                    this.dataForm.zslx = this.zslxData.join(",")
                    console.log("要发布的数据为：",this.dataForm)
                    this.$http
                    ({
                        url: `/bjba/article/save`,
                        method: 'post',
                        data: this.dataForm
                    }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                         })
                        this.visible = false
                        this.$emit
                        ('refreshDataList')
                    } else if(data && data.code === 500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                    })
                    }
                })
            },
            // 上传之前
            beforeUploadHandle (file) {
                if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
                    this.$message.error('只支持jpg、png、gif格式的图片！')
                    return false
                }
            },
            // 上传成功
            successHandle (response, file, fileList) {
                this.fileList = fileList
                console.log('111111111111111111111111111111')
                console.log(response)

                if (response && response.url) {
                    this.dataForm.img = response.url
                } else {
                    this.$message.error('上传图片出错')
                }
            },
            handleRemove(file, fileList) {
                this.dataForm.img=''
            },
            getCategory() {
                this.$http({
                    url: '/bjba/category/queryAll',
                    method: 'get'
                }).then(({data}) => {
                    this.categorys = data.data
                })
            },
            getCustomerType() {
                let that = this;
                this.$request
                    .get("/bjba/customertype/findAll")
                    .then((res) => {
                        console.log("customertype",res.data.data)
                        that.customertypeList = res.data.data;
                    });
            }
        }
    }
</script>
